import { create } from "zustand";
import { persist } from "zustand/middleware";
import { Tokens } from "~/services/auth";
import { TUser } from "~/types";
import { history } from "~/utils/history";

interface AuthState {
  isAuth: boolean;
  user: TUser | null;
  tokens: Tokens | null;
}

interface AuthActions {
  login: (tokens: Tokens) => void;
  logout: () => void;
  setMe: (user: TUser) => void;
}

export const useAuth = create<AuthState & AuthActions>()(
  persist(
    (set, get) => ({
      isAuth: false,
      user: null,
      tokens: null,
      
      login: (tokens) => set({ isAuth: true, tokens }),
      
      logout: async () => {
        localStorage.removeItem('auth-storage');
        
        if (history.navigate) {
          await history.navigate("/login");
        } else {
          console.error("Navigate function not initialized");
        }
        set({ isAuth: false, user: null, tokens: null });
      },
      
      setMe: (user) => {
        if (!user || !user.id) {
          console.error('Invalid user object received:', user);
          get().logout();
          return;
        }

        const safeUser = {
          ...user,
          firstName: user.first_name || user.firstName || '',
          lastName: user.last_name || user.lastName || '',
          first_name: user.first_name || user.firstName || '',
          last_name: user.last_name || user.lastName || ''
        };
        
        set({ user: safeUser });
      }  // <- Make sure this closing brace is here
    }),  // <- Make sure this closing parenthesis and brace are here
    {
      name: "auth-storage",
      version: 2,
      migrate: (persistedState: any, version: number) => {
        if (version < 2) {
          return { isAuth: false, user: null, tokens: null };
        }
        return persistedState;
      }
    }
  )
);